import styled from 'styled-components';
import colors from '../../../config/colors.json';
import ScreenSize from '../../../config/screenSizes.json';

export const StyledCard = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 8px;
    padding: 33px;
    background-color: ${colors.light};
    flex: 1;
    
    .mr-md-2 {
      margin-right: 10px;
    }
    
    .ml-md-2 {
      margin-left: 10px;
    }

    .content-header {
      display: flex;
      align-items: center;
      margin-bottom: 25px;
      
      img.icon {
        max-width: 40px;
        display: inline-block;
        vertical-align: middle;
        margin-top: 5px;
      }

    }

    h4 {
        font-family: Poppins, Heltica, Arial, sans-serif;
        font-weight: medium;
        font-size: 23px;
        letter-spacing: 0;
        color: ${colors.softDark};        
        vertical-align: middle;
        margin-bottom: 0;
        display: inline-block;
        line-height: 21px;
      }

      span {
        font-family: Poppins, Heltica, Arial, sans-serif;
        font-weight: medium;
        font-size: 23px;
        letter-spacing: 0;
        color: ${colors.lightRed};        
        vertical-align: middle;
        margin-bottom: 0;
        display: inline-block;
        margin-top: 10px;
        line-height: 21px;
      }
    
    .content-body {
        font-family: Poppins, Heltica, Arial, sans-serif;
        color: ${colors.grey};
        font-size: 17px;
        text-align: left;
        margin-top: 15px;
    }
`;

export const Title = styled.h1`
    font-family: Poppins, Heltica, Arial, sans-serif;
    font-weight: 600;
    color: #000;
    padding: 59px 0 0 34px;
    font-size: 44px;
    @media screen and (max-width: 1919px) {
        font-size: 30px;
    }
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        font-size: 20px;
    }
    @media screen and (max-width: ${ScreenSize.portrait}px) {
        padding: 33px 0 0 65px;
    }
`;
